export const EVENT_TYPES = [
  "Price Revision",
  "Scheme/Offer",
  "Product Launch",
  "Credit Policy Change",
  "Ledger/Outstanding",
  "Payment Due",
  "Compliance",
  "Marketing Opportunity",
  "Other",
];

const TYPE_STYLES = {
  "Price Revision": "bg-amber-50 dark:bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-300 dark:border-amber-500/40",
  "Scheme/Offer": "bg-emerald-50 dark:bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-300 dark:border-emerald-500/40",
  "Product Launch": "bg-cyan-50 dark:bg-cyan-500/10 text-cyan-600 dark:text-cyan-400 border-cyan-300 dark:border-cyan-500/40",
  "Credit Policy Change": "bg-rose-50 dark:bg-rose-500/10 text-rose-600 dark:text-rose-400 border-rose-300 dark:border-rose-500/40",
  "Ledger/Outstanding": "bg-purple-50 dark:bg-purple-500/10 text-purple-600 dark:text-purple-400 border-purple-300 dark:border-purple-500/40",
  "Payment Due": "bg-red-50 dark:bg-red-500/10 text-red-600 dark:text-red-400 border-red-300 dark:border-red-500/40",
  Compliance: "bg-orange-50 dark:bg-orange-500/10 text-orange-600 dark:text-orange-400 border-orange-300 dark:border-orange-500/40",
  "Marketing Opportunity": "bg-indigo-50 dark:bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 border-indigo-300 dark:border-indigo-500/40",
  Other: "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400 border-slate-300 dark:border-slate-700",
};

const SEVERITY_STYLES = {
  HIGH: "bg-rose-100 dark:bg-rose-500/15 text-rose-700 dark:text-rose-300 border-rose-300 dark:border-rose-500/40 animate-pulse-subtle",
  MEDIUM: "bg-amber-100 dark:bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-300 dark:border-amber-500/40",
  LOW: "bg-emerald-100 dark:bg-emerald-500/15 text-emerald-700 dark:text-emerald-300 border-emerald-800/80",
};

export const TypeBadge = ({ type }) => (
  <span
    data-testid={`type-badge-${(type || "other").toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    className={`inline-flex items-center rounded-md border px-2 py-0.5 text-sm font-mono font-semibold uppercase tracking-wider ${TYPE_STYLES[type] || TYPE_STYLES.Other}`}
  >
    {type}
  </span>
);

export const SeverityBadge = ({ severity, note }) => (
  <span
    data-testid={`severity-badge-${(severity || "low").toLowerCase()}`}
    className={`inline-flex items-center rounded-md border px-2 py-0.5 text-sm font-mono font-semibold ${SEVERITY_STYLES[severity] || SEVERITY_STYLES.LOW}`}
  >
    {note || severity}
  </span>
);

export const ConfidenceMeter = ({ value }) => {
  const pct = Math.round((value || 0) * 100);
  const color = pct >= 80 ? "bg-emerald-500" : pct >= 50 ? "bg-amber-500" : "bg-rose-500";
  return (
    <div className="flex items-center gap-2" data-testid="confidence-meter">
      <div className="h-1.5 w-16 rounded-full bg-slate-200 dark:bg-slate-700 overflow-hidden">
        <div className={`h-full ${color}`} style={{ width: `${pct}%` }} />
      </div>
      <span className="text-sm font-mono text-slate-600 dark:text-slate-400">{pct}%</span>
    </div>
  );
};
